export default {
  appName: 'benefits-mf-margin-exceeded',
  appFile: 'benefits-mf-margin-exceeded',
  environment: process.env.name,
  BFF_URI: process.env.BFF_URI,
  BUZZ_URL: process.env.BUZZ_URL,
  release: process.env.COMMIT_RELEASE,
}
